import * as Sentry from "@sentry/react";
import type { StaticDecode, TSchema } from "typebox";
import type * as TypeCompiler from "typebox/compile";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type PassedValidator<T extends TSchema> = TypeCompiler.Validator<{}, T>;

// A payload that has drifted is reported and used anyway: the values are still
// there, and a schema out of step with Rails should not take the page down.
export function decoded<T extends TSchema>(
  checker: PassedValidator<T>,
  value: unknown,
): StaticDecode<T> {
  try {
    return checker.Decode(value);
  } catch (error) {
    Sentry.captureException(error);

    return value as StaticDecode<T>;
  }
}
